/* eslint-disable */
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert } from 'react-bootstrap';

import { ss, cleanPhone, e164Phone, url, authJsonHeader } from '../../utils/util';

import './ChangePasswordForm.css';


class ChangePasswordForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      newPassword: '',
      errors: {},
    }
  }

  getValues() {
    let values = {
      newPassword: this.state.newPassword,
    };
    return values;
  }

  renderErrors(field) {
    if (!this.props.errors || !this.props.errors[field]) {
      return null;
    }

    let nodes = [];
    let i = 0;
    for (let error of this.props.errors[field]) {
      nodes.push(<div key={i++}>{error}</div>);
    }
    return <div className="error">{nodes}</div>;
  }

  render() {
    return (
      <Form className="change-password-form" onSubmit={(e) => this.props.onSubmit(e, this.getValues())}>
        <FormGroup>
          <ControlLabel>New password</ControlLabel>
          <HelpBlock className="helptext">No character or length requirements! Pick a bad password at your own risk.</HelpBlock>
          <FormControl
            type="password"
            value={this.state.newPassword}
            onChange={ss(this, 'newPassword')}
          />
          {this.renderErrors('newPassword')}
        </FormGroup>

        <FormGroup>
          <Button bsStyle="primary" type="submit">{this.props.buttonText}</Button>{' '}
          {this.props.cancelText && <Button bsStyle="default" onClick={this.props.onCancel}>{this.props.cancelText}</Button>}
        </FormGroup>
      </Form>
    );
  }
}


function mapStateToProps(state) {
  return {
  };
}

export default connect(mapStateToProps)(ChangePasswordForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/ChangePasswordForm.js
 **/